import { Modal, Text, Group, Button } from "@mantine/core";

interface Props {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  loading?: boolean;
}

export default function ConfirmModal({
  opened,
  onClose,
  onConfirm,
  title = "Устгах",
  message = "Та итгэлтэй байна уу?",
  loading = false,
}: Props) {
  return (
    <Modal opened={opened} onClose={onClose} title={title} size="sm">
      <Text mb="lg">{message}</Text>
      <Group justify="flex-end">
        <Button variant="default" onClick={onClose}>
          Болих
        </Button>
        <Button color="red" onClick={onConfirm} loading={loading}>
          Устгах
        </Button>
      </Group>
    </Modal>
  );
}
